<template>
    <div class="tw-mr-3 tw-text-center">
        <template v-if="media.type === 'image'">
            <img class="tw-pb-2" :src="media.url">
            <p class="tw-text-sm tw-text-gray-300 tw-italic">{{ media.value }}</p>
        </template>

        <template v-else-if="media.type === 'video'">
            <video class="tw-pb-2" width="400" controls>
                <source :src="media.url" type="video/mp4">
                <source :src="media.url" type="video/ogg">
                {{ translations['quiz.nohtml5'] }}
            </video>
            <p class="tw-text-sm tw-text-gray-300 tw-italic">{{ media.value }}</p>
        </template>

        <template v-else>
            <p v-html="media.value"></p>
        </template>
    </div>
</template>

<script>
    let _ = require('lodash');

    export default {
        name: "QuestionMedia",

        props: ['media']
    }
</script>